import CurrentPlanCard from "../subscription/CurrentPlanCard";
import UsageCard from "../subscription/UsageCard";
import LimitHandlingCard from "../subscription/LimitHandlingCard";
import UpgradeCard from "../subscription/UpgradeCard";
import PlanFeaturesCard from "../subscription/PlanFeaturesCard";
import SubscriptionAlertBanner from "../subscription/SubscriptionAlertBanner";
import { useBillingFlow } from "../providers/BillingFlowProvider";
import { useUser } from "routes/dataroutes/UserData";

export default function SubscriptionTab() {
  const { flowType } = useBillingFlow();
  const user = useUser();

  return (
    <div className="flex flex-col gap-8 pb-8">
      {user?.isBlocked && (
        <SubscriptionAlertBanner
          type="blocked"
          blockingCode={user.blockingCode}
        />
      )}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <CurrentPlanCard />
        <UsageCard />
      </div>
      {flowType !== 'free' && !user?.isBlocked && <LimitHandlingCard />}
      <UpgradeCard />
      <PlanFeaturesCard />
    </div>
  );
}
